import * as React from 'react';
import { PermissionsStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels/Panel';
import { IAToggle } from '../../toggle/Toggle';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAccordion } from '../../../interfaces/IAccordion';
import { IAAccordion } from '../../accordion/Accordion';
import { IUserPermission } from '../../../interfaces/IUserPermission';
import { IAPersonaSmall } from '../../personaSmall/PersonaSmall';
import { Helper } from '../../../Helper';
import { PermissionSwitch } from './permissionSwitch/PermissionSwitch';
import { IAMessageBar } from '../../messageBar/MessageBar';
import PermissionsService from '../../../services/PermissionsService';
import { IPermissionResponse } from '../../../interfaces/IPermissionResponse';
import { PeopleSearch } from './peopleSearch/PeopleSearch'
import { IAButton } from '../../button/Button';
import { UniquePermissionsResult } from '../../../interfaces/UniquePermissionsResult';
import { ISharePointUser } from '../../../interfaces/ISharePointUser';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../../global';
import { IATooltip } from '../../tooltip/Tooltip';
import { IAIcon } from '../../icon/Icon';

export interface IPermissionsPanelProps {
  permissionsStore?: PermissionsStore;
  update: () => void;
}

export interface IPermissionsPanelState {
  errors: PermissionsErrorType[];
}

enum PermissionsErrorType {
  Forbidden,
  Unknown
}

@inject('permissionsStore')
@observer
export class PermissionsPanel extends React.Component<IPermissionsPanelProps, IPermissionsPanelState> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IPermissionsPanelProps) {
    super(props);
    this.state = {
      errors: []
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private renderPermissions(): any {
    const administrators = [];
    const editors = [];
    const readers = [];
    if (this.props.permissionsStore.permissions && this.props.permissionsStore.permissions.length > 0) {
      this.props.permissionsStore.permissions.forEach((userPermission: IUserPermission) => {
        switch (userPermission.role) {
          case "Administrator":
            administrators.push(
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IAPersonaSmall
                  profileImage={Helper.getProfileOrGroupImage(this.props.permissionsStore.environment, this.props.permissionsStore.tenant, this.props.permissionsStore.token, userPermission.user.email, userPermission.user.userName)}
                  name={userPermission.user.title}
                  title={Helper.getProfileOrGroupType(this.localizationService, userPermission.user.userName)}
                  metadata={
                    <PermissionSwitch
                      selectedOption={{
                        title: this.localizationService.strings.Permissions_Owner,
                        key: "Administrator"
                      }}
                      selectOption={(selectedOption: "Administrator" | "Editor" | "Reader" | "Remove") => {
                        this.updatePermission(selectedOption, userPermission);
                      }}
                    />
                  }
                  backgroundColor="#025159"
                  styles={{
                    minWidth: 150,
                    marginTop: 11,
                    clear: "both"
                  }
                  }
                  highlightColor={this.props.permissionsStore.highlightColor}
                />
                {
                  userPermission.onlyPresentOnContentOrganizerInstance &&
                  <IATooltip
                    content="Tooltip"
                    type={"bubble"}
                    styles={{
                      width: 300,
                      textAlign: "left",
                      color: "#333333",
                      display: 'inline',
                      fontWeight: 'normal',
                    }}
                    rootStyles={{
                      float: 'none',
                      display: 'inline',
                    }}
                    componentContent={<>{this.localizationService.strings.Permissions_AdminUserAddedOnlyOnSite}</>}
                  >
                    <IAIcon
                      url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Info/SVG/ic_fluent_info_28_regular.svg"
                      size={14}
                      color={"#03787c"}
                      style={{
                        marginLeft: 7,
                        marginTop: 3,
                        height: 13,
                        display: 'inline',
                        float: "left"
                      }}
                    />
                  </IATooltip>

                }

              </div>

            );
            break;
          case "Editor":
            editors.push(
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IAPersonaSmall
                  profileImage={Helper.getProfileOrGroupImage(this.props.permissionsStore.environment, this.props.permissionsStore.tenant, this.props.permissionsStore.token, userPermission.user.email, userPermission.user.userName)}
                  name={userPermission.user.title}
                  title={Helper.getProfileOrGroupType(this.localizationService, userPermission.user.userName)}
                  metadata={
                    <PermissionSwitch
                      selectedOption={{
                        title: this.localizationService.strings.Permissions_Member,
                        key: "Editor"
                      }}
                      selectOption={(selectedOption: "Administrator" | "Editor" | "Reader" | "Remove") => {
                        this.updatePermission(selectedOption, userPermission);
                      }}
                    />
                  }
                  backgroundColor="#025159"
                  styles={{
                    minWidth: 150,
                    marginTop: 11,
                    clear: "both"
                  }}
                  highlightColor={this.props.permissionsStore.highlightColor}
                />

                {
                  userPermission.onlyPresentOnContentOrganizerInstance &&
                  <IATooltip
                    content="Tooltip"
                    type={"bubble"}
                    styles={{
                      width: 300,
                      textAlign: "left",
                      color: "#333333",
                      display: 'inline',
                      fontWeight: 'normal',
                    }}
                    rootStyles={{
                      float: 'none',
                      display: 'inline',
                    }}
                    componentContent={<>{this.localizationService.strings.Permissions_AdminUserAddedOnlyOnSite}</>}
                  >
                    <IAIcon
                      url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Info/SVG/ic_fluent_info_28_regular.svg"
                      size={14}
                      color={"#03787c"}
                      style={{
                        marginLeft: 7,
                        marginTop: 3,
                        height: 13,
                        display: 'inline',
                        float: "left"
                      }}
                    />
                  </IATooltip>

                }
              </div>
            );
            break;
          case "Reader":
            readers.push(
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IAPersonaSmall
                  profileImage={Helper.getProfileOrGroupImage(this.props.permissionsStore.environment, this.props.permissionsStore.tenant, this.props.permissionsStore.token, userPermission.user.email, userPermission.user.userName)}
                  name={userPermission.user.title}
                  title={Helper.getProfileOrGroupType(this.localizationService, userPermission.user.userName)}
                  metadata={
                    // do not show options on "everyone except external users" when showing Readers (only for Admin application)
                    (userPermission.user.userName.indexOf("|rolemanager|") === -1 || this.props.permissionsStore.selectedApplication !== this.props.permissionsStore.ADMIN) &&
                    <PermissionSwitch
                      selectedOption={{
                        title: this.localizationService.strings.Permissions_Reader,
                        key: "Reader"
                      }}
                      selectOption={(selectedOption: "Administrator" | "Editor" | "Reader" | "Remove") => {
                        this.updatePermission(selectedOption, userPermission);
                      }}
                    />
                  }
                  backgroundColor="#025159"
                  styles={{
                    minWidth: 150,
                    marginTop: 11,
                    clear: "both"
                  }}
                  highlightColor={this.props.permissionsStore.highlightColor}
                />

                {
                  userPermission.onlyPresentOnContentOrganizerInstance &&
                  <IATooltip
                    content="Tooltip"
                    type={"bubble"}
                    styles={{
                      width: 300,
                      textAlign: "left",
                      color: "#333333",
                      display: 'inline',
                      fontWeight: 'normal',
                    }}
                    rootStyles={{
                      float: 'none',
                      display: 'inline',
                    }}
                    componentContent={<>{this.localizationService.strings.Permissions_AdminUserAddedOnlyOnSite}</>}
                  >
                    <IAIcon
                      url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Info/SVG/ic_fluent_info_28_regular.svg"
                      size={14}
                      color={"#03787c"}
                      style={{
                        marginLeft: 7,
                        marginTop: 3,
                        height: 13,
                        display: 'inline',
                        float: "left"
                      }}
                    />
                  </IATooltip>

                }

              </div>
            );
            break;
          default:
            break;
        }
      });
    }
    return {
      "Administrator": administrators,
      "Editor": editors,
      "Reader": readers,
    }
  }

  private updatePermission(selectedOption: "Administrator" | "Editor" | "Reader" | "Remove", userPermission: IUserPermission) {
    const existingRole = userPermission.role;
    if (selectedOption !== "Remove") {
      userPermission.role = selectedOption;
      PermissionsService.addUserToGroup(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.selectedApplication, userPermission.user.userName, selectedOption, this.props.permissionsStore.selectedInstance ? this.props.permissionsStore.selectedInstance.instanceName ? this.props.permissionsStore.selectedInstance.instanceName : "Default" : undefined).then((status) => {
        if (status === 201) {
          this.deleteUser(userPermission.user.userName, existingRole);
        }
      });
    } else {
      this.deleteUser(userPermission.user.userName, existingRole);
    }
  }

  private deleteUser(userName: string, userRole: "Administrator" | "Editor" | "Reader"): void {
    PermissionsService.deleteUserFromGroup(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.selectedApplication, userName, userRole, this.props.permissionsStore.selectedInstance ? this.props.permissionsStore.selectedInstance.instanceName ? this.props.permissionsStore.selectedInstance.instanceName : "Default" : undefined).then((deleteStatus) => {
      if (deleteStatus === 204) {
        if (this.props.permissionsStore.selectedInstance) {
          this.getUniquePermissions();
        } else {
          this.getPermissionsForApplication();
        }
      }
    });
  }

  private getStatus(): void {
    new FetchProxy(localStorage.getItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`), {
      method: "GET",
      credentials: "same-origin",
      mode: "cors",
      headers: new Headers({
        "AuthToken": this.props.permissionsStore.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }).withContainer(sdkContainerInstance)
      .fetch()
      .then((response) => {
        if (!response.ok) {
          return response.status;
        } else {
          return response.json();
        }
      }).then(response => {
        console.log(response.runtimeStatus);
        if (response.runtimeStatus === "Failed") {
          localStorage.removeItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`);
          this.props.permissionsStore.selectedInstance.hasUniquePermissions =
            this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.Yes
              ? UniquePermissionsResult.No
              : UniquePermissionsResult.Yes;
          this.forceUpdate();
        } else if (response.runtimeStatus === "Pending" || response.runtimeStatus === "Running") {
          setTimeout(() => {
            this.forceUpdate();
          }, 1000);
        } else if (response.runtimeStatus === "Completed") {
          localStorage.removeItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`);
          this.forceUpdate();
          this.props.update();
          if (this.props.permissionsStore.selectedInstance.hasUniquePermissions) {
            this.getUniquePermissions();
          }
        }
      })
  }

  private getPermissionsForApplication(): void {
    PermissionsService.getPermission(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.selectedApplication).then((userPermissions: IUserPermission[]) => {
      console.log(userPermissions);
      this.props.permissionsStore.permissions = userPermissions ? userPermissions : [];
      const permissions = this.renderPermissions()
      if (this.props.permissionsStore.permissionItems) {
        this.props.permissionsStore.permissionItems[0].content = <div>{permissions["Administrator"]}</div>
        this.props.permissionsStore.permissionItems[1].content = <div>{permissions["Editor"]}</div>
        this.props.permissionsStore.permissionItems[2].content = <div>{permissions["Reader"]}</div>
        this.props.permissionsStore.permissionItems[0].expanded = true;
        this.props.permissionsStore.permissionItems[1].expanded = true;
        this.props.permissionsStore.permissionItems[2].expanded = true;
      } else {
        this.props.permissionsStore.permissionItems = [
          {
            title: this.localizationService.strings.Permissions_Owners,
            content: <div>{permissions["Administrator"]}</div>,
            toolTip: this.localizationService.strings[`Permissions_PanelAdministrator${this.props.permissionsStore.selectedApplication}Tooltip`],
            expanded: true,
          },
          {
            title: this.localizationService.strings.Permissions_Members,
            content: <div>{permissions["Editor"]}</div>,
            toolTip: this.localizationService.strings[`Permissions_PanelEditor${this.props.permissionsStore.selectedApplication}Tooltip`],
            expanded: true,
          },
          {
            title: this.localizationService.strings.Permissions_Readers,
            content: <div>{permissions["Reader"]}</div>,
            toolTip: this.localizationService.strings[`Permissions_PanelReader${this.props.permissionsStore.selectedApplication}Tooltip`],
            expanded: true,
          }
        ];
      }
      this.forceUpdate();
    });
  }

  private getUniquePermissions(): void {
    PermissionsService.getPermission(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.selectedApplication, this.props.permissionsStore.selectedInstance ? this.props.permissionsStore.selectedInstance.instanceName ? this.props.permissionsStore.selectedInstance.instanceName : "Default" : undefined).then((userPermissions: IUserPermission[]) => {
      console.log(userPermissions);
      this.props.permissionsStore.permissions = userPermissions ? userPermissions : [];
      const permissions = this.renderPermissions()
      if (this.props.permissionsStore.permissionItems) {
        this.props.permissionsStore.permissionItems[0].content = <div>{permissions["Administrator"]}</div>
        this.props.permissionsStore.permissionItems[1].content = <div>{permissions["Editor"]}</div>
        this.props.permissionsStore.permissionItems[2].content = <div>{permissions["Reader"]}</div>
        this.props.permissionsStore.permissionItems[0].expanded = true;
        this.props.permissionsStore.permissionItems[1].expanded = true;
        this.props.permissionsStore.permissionItems[2].expanded = true;
      } else {
        this.props.permissionsStore.permissionItems = [
          {
            title: this.localizationService.strings.Permissions_Owners,
            content: <div>{permissions["Administrator"]}</div>,
            expanded: true,
          },
          {
            title: this.localizationService.strings.Permissions_Members,
            content: <div>{permissions["Editor"]}</div>,
            expanded: true,
          },
          {
            title: this.localizationService.strings.Permissions_Readers,
            content: <div>{permissions["Reader"]}</div>,
            expanded: true,
          }
        ];
      }
      this.forceUpdate();
    });
  }

  private getPermissionsTitleFromKey(role: "Administrator" | "Editor" | "Reader"): string {
    switch (role) {
      case "Administrator":
        return this.localizationService.strings.Permissions_Owner;
      case "Editor":
        return this.localizationService.strings.Permissions_Member;
      case "Reader":
        return this.localizationService.strings.Permissions_Reader;
    }
  }

  private addError(errorType: PermissionsErrorType): void {
    if (this.state.errors.indexOf(errorType) == -1) {
      let errors = [...this.state.errors];
      errors.push(errorType);
      this.setState({ errors: errors })
    }
  }

  private removeError(errorType: PermissionsErrorType): void {
    this.setState({
      errors: this.state.errors.filter(val => {
        return val != errorType;
      })
    });
  }

  private getErrorLabelForType(errorType: PermissionsErrorType): string {
    switch (errorType) {
      case PermissionsErrorType.Forbidden:
        return new LocalizationService().strings.Permissions_ErrorForbidden;
      case PermissionsErrorType.Unknown:
        return new LocalizationService().strings.Permissions_ErrorUnknown;
      default:
        break;
    }
  }

  public render(): JSX.Element {
    if (this.props.permissionsStore.selectedInstance != undefined && localStorage.getItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`)) {
      this.getStatus();
    }
    if (this.props.permissionsStore.selectedApplication && this.props.permissionsStore.permissions === undefined && this.props.permissionsStore.selectedInstance && this.props.permissionsStore.selectedInstance.hasUniquePermissions) {
      this.getUniquePermissions();
    }
    if (this.props.permissionsStore.selectedInstance === undefined && this.props.permissionsStore.selectedApplication && this.props.permissionsStore.permissions === undefined) {
      this.getPermissionsForApplication();
    }
    const content = (
      <div style={{ padding: "0px 40px" }}>
        <div style={{ marginTop: 20 }}>
          <IAMessageBar
            type="information"
            onDismiss={() => { }}
            icon="Info"
            content={this.localizationService.strings.Permissions_Infobox}
            showIcon={true}
            showCloseButton={false}
            style={{ float: "none" }}
          />
        </div>
        {this.props.permissionsStore.selectedInstance !== undefined && !localStorage.getItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`) && !this.props.permissionsStore.loading &&
          <div style={{ marginTop: 20 }}>
            {this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.No && this.props.permissionsStore.selectedApplication != this.props.permissionsStore.CONTENT_ORGANIZER &&
              <IAMessageBar
                type="information"
                onDismiss={() => { }}
                icon="Info"
                content={this.localizationService.strings.Permissions_InheritPermissions + this.getLocalizedStringForApplication(this.props.permissionsStore.selectedApplication)}
                showIcon={true}
                showCloseButton={false}
                style={{ float: "none" }}
              />
            }
          </div>
        }
        {this.props.permissionsStore.selectedInstance?.hasSpecialPermissions &&
          <div style={{ marginTop: 20 }}>
            <IAMessageBar
              type="warning"
              onDismiss={() => { }}
              icon="Attention"
              content={this.localizationService.strings.Permissions_SpecialPermissionsTooltip}
              showIcon={true}
              showCloseButton={false}
              style={{
                whiteSpace: 'break-spaces',
                padding: '30px',
                float: "none",
              }}
            />
          </div>
        }
        {this.props.permissionsStore.selectedInstance != undefined && (localStorage.getItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`) || this.props.permissionsStore.loading) &&
          <IAMessageBar
            type="information"
            onDismiss={() => { }}
            icon="Info"
            content={!this.props.permissionsStore.selectedInstance.hasUniquePermissions ? this.localizationService.strings.Permissions_RemovingUniquePermissions : this.localizationService.strings.Permissions_AddingUniquePermissions}
            showIcon={true}
            showCloseButton={false}
            style={{ float: "none" }}
          />
        }
        {this.props.permissionsStore.selectedInstance && !(this.props.permissionsStore.selectedApplication == this.props.permissionsStore.CONTENT_ORGANIZER && this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.Yes) &&
          <div style={{ marginTop: 20 }}>
            <IAToggle
              label={`${this.localizationService.strings.Permissions_AddUniquePermissions} ${this.props.permissionsStore.selectedInstance.title}?`}
              toolTip={this.localizationService.strings.Permissions_AddUniquePermissionsTooltip}
              checked={this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.Yes}
              color={this.props.permissionsStore.highlightColor}
              onChange={() => {
                this.props.permissionsStore.loading = true;
                this.props.permissionsStore.selectedInstance.hasUniquePermissions =
                  this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.Yes
                    ? UniquePermissionsResult.No
                    : UniquePermissionsResult.Yes;
                this.props.permissionsStore.selectedInstance.hasSpecialPermissions =
                  this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.No
                    ? false
                    : this.props.permissionsStore.selectedInstance.hasSpecialPermissions;
                PermissionsService.toggleUniquePermissions(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.selectedApplication, this.props.permissionsStore.selectedInstance ? this.props.permissionsStore.selectedInstance.instanceName ? this.props.permissionsStore.selectedInstance.instanceName : "Default" : undefined, this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.Yes).then((permissionResponse: IPermissionResponse) => {
                  Helper.setLocalStorage(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`, permissionResponse.statusQueryGetUri);
                  this.props.permissionsStore.loading = false;
                  this.forceUpdate();
                });
              }}
              disabled={this.props.permissionsStore.loading || localStorage.getItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`) != undefined}
            />
          </div>
        }
        {((this.props.permissionsStore.selectedApplication && this.props.permissionsStore.selectedInstance && this.props.permissionsStore.selectedInstance.hasUniquePermissions == UniquePermissionsResult.Yes && !localStorage.getItem(`statusQueryGetUri_${this.props.permissionsStore.selectedApplication}_${this.props.permissionsStore.selectedInstance.instanceName}`)) || (this.props.permissionsStore.selectedInstance === undefined && this.props.permissionsStore.selectedApplication)) && !this.props.permissionsStore.loading &&
          <div>
            <PeopleSearch
              token={this.props.permissionsStore.token}
              tenant={this.props.permissionsStore.tenant}
              environment={this.props.permissionsStore.environment}
              placeholder={this.localizationService.strings.Permissions_AddPlaceholder}
              siteName={this.props.permissionsStore.selectedApplication}
              onSelect={(user: ISharePointUser) => {
                this.props.permissionsStore.userToAdd = {
                  user: Helper.syncUserProperties({
                    displayName: user.title,
                    email: user.email,
                    userName: user.loginName,
                    userPrincipalName: user.userPrincipalName,
                  }),
                  role: "Reader"
                };
              }}
              highlightColor={this.props.permissionsStore.highlightColor}
            />
            {this.state.errors.length > 0 &&
              <div>
                <div style={{ clear: 'both' }}></div>
                {this.state.errors.map(errorType =>
                  <IAMessageBar
                    type="error"
                    onDismiss={() => { this.removeError(errorType) }}
                    icon="Attention"
                    content={this.getErrorLabelForType(errorType)}
                    showIcon={true}
                    showCloseButton={true}
                    style={{
                      marginTop: 1,
                      whiteSpace: 'break-spaces'
                    }}
                  />
                )}

              </div>
            }
            {this.props.permissionsStore.userToAdd &&
              <div>
                <IAPersonaSmall
                  profileImage={Helper.getProfileOrGroupImage(this.props.permissionsStore.environment, this.props.permissionsStore.tenant, this.props.permissionsStore.token, this.props.permissionsStore.userToAdd.user.email, this.props.permissionsStore.userToAdd.user.userName)}
                  name={this.props.permissionsStore.userToAdd.user.title}
                  title={Helper.getProfileOrGroupType(this.localizationService, this.props.permissionsStore.userToAdd.user.userName)}
                  metadata={
                    <PermissionSwitch
                      selectedOption={{
                        title: this.getPermissionsTitleFromKey(this.props.permissionsStore.userToAdd.role),
                        key: this.props.permissionsStore.userToAdd.role
                      }}
                      selectOption={(selectedOption: "Administrator" | "Editor" | "Reader" | "Remove") => {
                        if (selectedOption === "Remove") {
                          this.props.permissionsStore.userToAdd = undefined;
                        } else {
                          this.props.permissionsStore.userToAdd.role = selectedOption;
                        }
                      }}
                    />
                  }
                  backgroundColor="#025159"
                  styles={{
                    width: "30%",
                    marginTop: 13,
                    clear: "both"
                  }
                  }
                  highlightColor={this.props.permissionsStore.highlightColor}
                />
                <IAButton
                  label={this.localizationService.strings.Permissions_AddButton}
                  style={{
                    marginTop: 13,
                    float: "left"
                  }}
                  buttonColor={this.props.permissionsStore.highlightColor}
                  arialable={this.localizationService.strings.Permissions_AddButton}
                  onClick={() => {
                    PermissionsService.addUserToGroup(this.props.permissionsStore.environment, this.props.permissionsStore.token, this.props.permissionsStore.tenant, this.props.permissionsStore.selectedApplication, this.props.permissionsStore.userToAdd.user.userName, this.props.permissionsStore.userToAdd.role, this.props.permissionsStore.selectedInstance ? this.props.permissionsStore.selectedInstance.instanceName ? this.props.permissionsStore.selectedInstance.instanceName : "Default" : undefined).then((status) => {
                      this.props.permissionsStore.userToAdd = undefined;
                      if (status === 201) {
                        if (this.props.permissionsStore.selectedInstance) {
                          this.getUniquePermissions();
                        } else {
                          this.getPermissionsForApplication();
                        }
                      } else if (status === 403) {
                        this.addError(PermissionsErrorType.Forbidden);
                      } else {
                        this.addError(PermissionsErrorType.Unknown);
                      }
                    });
                  }}
                />
              </div>
            }
            <div style={{ marginLeft: -8, width: "100%", height: "auto" }}>
              <IAAccordion
                items={this.props.permissionsStore.permissionItems}
                color="#333333"
                backgroundColor="#ffffff"
                collapseOthers={false}
                onChange={(items: IAccordion[]) => {
                  this.props.permissionsStore.permissionItems = items;
                  this.forceUpdate();
                }}
              />
            </div>
          </div>
        }
      </div >
    )
    return (
      <IAPanel
        showNavigationBar={true}
        navigatorTitle={this.props.permissionsStore.selectedInstance !== undefined ? `${this.getLocalizedStringForApplication(this.props.permissionsStore.selectedApplication)} > ${this.props.permissionsStore.selectedInstance.title}` : this.getLocalizedStringForApplication(this.props.permissionsStore.selectedApplication)}
        component={"Permissions"}
        open={this.props.permissionsStore.selectedApplication !== undefined}
        transition="slide"
        width={window.innerWidth < 667 ? window.innerWidth : 600}
        isMobile={false}
        highlightColor={this.props.permissionsStore.highlightColor}
        marginTop={this.props.permissionsStore.marginTop}
        close={() => {
          this.props.permissionsStore.selectedApplication = undefined;
          this.props.permissionsStore.selectedInstance = undefined;
          this.props.permissionsStore.permissions = undefined;
          this.props.permissionsStore.permissionItems = undefined;
          this.props.permissionsStore.userToAdd = undefined;
        }}
      >
        {content}
      </IAPanel>
    );
  }

  private getLocalizedStringForApplication(application: string): string {
    switch (application) {
      case this.props.permissionsStore.ADMIN:
        return this.localizationService.strings.Admin_Admin;
      case this.props.permissionsStore.MOBILE_APP:
        return this.localizationService.strings.Admin_MobileApp;
      case this.props.permissionsStore.EVENTS:
        return this.localizationService.strings.Admin_Events;
      case this.props.permissionsStore.NAVIGATOR:
        return this.localizationService.strings.Admin_Navigator;
      case this.props.permissionsStore.INFOSCREEN:
        return this.localizationService.strings.Admin_Infoscreen;
      case this.props.permissionsStore.TOOLBOX:
        return this.localizationService.strings.Admin_Toolbox;
      case this.props.permissionsStore.MESSAGES:
        return this.localizationService.strings.Admin_Messages;
      case this.props.permissionsStore.CONTENT_CREATOR:
        return this.localizationService.strings.Admin_ContentCreator;
      case this.props.permissionsStore.CONTENT_ORGANIZER:
        return this.localizationService.strings.Admin_ContentOrganizer;
    }
  }
}